import BoltIcon from '@mui/icons-material/Bolt';

import { UserPermissions } from '@models/user';
import { useExecuteScheduledPaymentMutation } from '@features/customers/mutations';
import { useMeStore } from '@features/users/store';
import { useConfirm } from '@hooks/useConfirm';
import { userHasPermission } from '@utils/access';

import s from './ExecutePaymentButton.module.css';

type ExecutePaymentButtonProps = {
  customerId: string;
  scheduledPaymentId: string;
};

function ExecutePaymentButton({ customerId, scheduledPaymentId }: ExecutePaymentButtonProps) {
  const executePayment = useExecuteScheduledPaymentMutation();
  const confirm = useConfirm();
  const me = useMeStore();

  // Charging the customer is a write action
  if (!me || !userHasPermission(me, UserPermissions.EDIT_USERS)) return null;

  const handleClick = async () => {
    const confirmed = await confirm(
      `This will charge  right away instead of waiting for the scheduled date, are you sure you want to proceed?`,
      {
        title: 'Execute payment now?',
        confirmLabel: 'Execute payment',
        cancelLabel: 'Keep scheduled',
        tone: 'success',
      },
    );
    if (!confirmed) return;
    executePayment.mutate({ customerId, scheduledPaymentId });
  };

  return (
    <button
      type="button"
      className={s.executeBtn}
      onClick={handleClick}
      disabled={executePayment.isPending}>
      <BoltIcon sx={{ fontSize: 14 }} />
      {executePayment.isPending ? 'Executing…' : 'Execute'}
    </button>
  );
}

export default ExecutePaymentButton;
